import React from 'react';
import { Checkbox } from '@atlaskit/checkbox';
import { fg } from '@atlaskit/platform-feature-flags';
import SectionMessage from '@atlaskit/section-message';
import { getInputAccessibilityDescriptionId } from '../common/accessibilityUtils';
import { ChoiceQuestionStyles } from '../common/commonStyles';
import { ChoiceFieldWrapper, ChoicePlaceholder } from '../common/questionWrappers';
import { EditOtherOption } from './EditOtherOption';
export var EditMultiChoice = function EditMultiChoice(_ref) {
  var id = _ref.id,
    errorId = _ref.errorId,
    descriptionId = _ref.descriptionId,
    options = _ref.options,
    value = _ref.value,
    isInvalid = _ref.isInvalid,
    isRequired = _ref.isRequired,
    onChange = _ref.onChange,
    hasOtherOption = _ref.hasOtherOption,
    otherOptionSelected = _ref.otherOptionSelected,
    otherOptionText = _ref.otherOptionText,
    onOtherOptionTextChange = _ref.onOtherOptionTextChange,
    warningMessage = _ref.warningMessage;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ChoiceFieldWrapper, {
    isDisabled: false,
    isInvalid: isInvalid,
    "aria-describedby": fg('jsm-accessibility-fixes') ? getInputAccessibilityDescriptionId(errorId, descriptionId, isInvalid) : undefined
  }, /*#__PURE__*/React.createElement("div", null, options !== null && options !== void 0 && options.length ? /*#__PURE__*/React.createElement(ChoiceQuestionStyles, null, /*#__PURE__*/React.createElement("div", {
    id: id
  }, options.map(function (option) {
    return /*#__PURE__*/React.createElement(Checkbox, {
      id: "".concat(id, "-option-").concat(option.value),
      name: id,
      key: option.value,
      value: option.value,
      label: option.label,
      isChecked: value === null || value === void 0 ? void 0 : value.includes(option),
      onChange: onChange,
      "aria-required": isRequired
    });
  }))) : /*#__PURE__*/React.createElement(ChoicePlaceholder, null), hasOtherOption && otherOptionSelected && /*#__PURE__*/React.createElement(EditOtherOption, {
    dropdown: false,
    value: otherOptionText,
    isDisabled: !otherOptionSelected,
    onChange: onOtherOptionTextChange,
    id: id
  }))), warningMessage && /*#__PURE__*/React.createElement(SectionMessage, {
    appearance: "warning"
  }, warningMessage));
};